import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, UntypedFormGroup } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { Invoice, PaymentLinkState } from "src/app/frontoffice/order/model/invoice.model";
import { ReceiptPaymentModel } from "src/app/frontoffice/order/model/receiptpayment.model";
import { SettlementReadInvoiceEnum, SettlementReadInvoiceModel } from "../../model/settlementreadinvoice.model";
import { CashierSettlementModel } from "../../model/usersettlement.model";

@Component({
  selector: "settlementinvoicesmodal",
  templateUrl: "./invoicesmodal.component.html",
  styleUrls: ["./invoicesmodal.component.scss"],
})
export class InvoicesModalComponent extends BaseFormComponent<Invoice> {
  invoices: any;
  CostSpents: any;
  settlement: PagingDataResult<CashierSettlementModel>;
  reciptpayment: PagingDataResult<ReceiptPaymentModel>;
  currentData: PagingDataResult<any> = new PagingDataResult<any>();
  hasColumns: boolean = false;
  // SettledPersonnelId: number;
  // invoicekind: number;
  @ViewChild(KGridComponent) grid: KGridComponent;
  ReadInvoiceModel: SettlementReadInvoiceModel;
  defaultFilters: GridFilter[];
  filters: GridFilter[] = [
    {
      Filed: "CreatedDate",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
    {
      Filed: "SaleMethodBranchId",
      Value: 0,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    },
  ];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.label = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.Invoices");
    this.areaName = "RestaurantSale";
  }
  async ngOnInit() {
    const newGroup: any = {};
    this.formGroup = new UntypedFormGroup(newGroup);
    this.FillData(undefined);
    this.filters.push({
      Filed: "CreatedDate",
      Value: null,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    });
    this.filters.push({
      Filed: "SaleMethodBranchId",
      Value: null,
      Skip: 0,
      Take: 0,
      Operator: "desc",
      Type: "S",
    });
  }

  FillData(event: GridFilter[]) {
    let ReadInvoiceModel = new SettlementReadInvoiceModel();
    ReadInvoiceModel.SettledUserlId = this.ReadInvoiceModel.SettledUserlId;
    ReadInvoiceModel.UntilDate = this.ReadInvoiceModel.UntilDate;
    ReadInvoiceModel.Status = this.ReadInvoiceModel.Status;
    ReadInvoiceModel.UntilTime = this.ReadInvoiceModel.UntilTime;
    ReadInvoiceModel.InvoiceIds = this.ReadInvoiceModel.InvoiceIds;
    if (!event) {
      event = [];
      let BranchId = this.accountService.getCurrentUser().CurrentBranchId;
      if (BranchId !== undefined)
        event.push({
          Filed: "BranchId",
          Type: "F",
          Value: BranchId,
          Operator: "eq",
          Logic: "and",
          Skip: event[0]?.Skip ?? 0,
          Take: event[0]?.Take ?? 10,
        });
    }
    ReadInvoiceModel.Filters = [...this.defaultFilters, ...event];
    if (this.grid && this.grid.isRefreshing) return;
    if (this.grid) this.grid.isRefreshing = true;
    this.httpCommonService
      .create("CashierSettlemet/GetInvoicesList", ReadInvoiceModel)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: SettlementReadInvoiceModel) => {
        if (data?.Invoices?.Data?.length) this.setPaymentLinkStateString(data.Invoices);
        switch (data.Status) {
          case SettlementReadInvoiceEnum.Cleard:
            this.currentData = data.Invoices;
            this.invoices = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Pending:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Passive:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Cancelled:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Deleted:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Customer:
            this.reciptpayment = data.ReceiptPayments;
            this.currentData = data.ReceiptPayments;
            break;
          case SettlementReadInvoiceEnum.Personnel:
            this.currentData = data.Settlements;
            this.settlement = data.Settlements;
            break;
          case SettlementReadInvoiceEnum.PaymentPersonnel:
            this.currentData = data.Settlements;
            this.settlement = data.Settlements;
            break;
          case SettlementReadInvoiceEnum.Delivery:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.Discount:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
          case SettlementReadInvoiceEnum.CostSpent:
            this.CostSpents = data.CostSpents;
            this.currentData = data.CostSpents;
            break;
          default:
            this.invoices = data.Invoices;
            this.currentData = data.Invoices;
            break;
        }
        if (!this.hasColumns) this.setColumns();
      });
  }

  setPaymentLinkStateString(Invoices: PagingDataResult<Invoice>) {
    Invoices.Data = Invoices.Data.map((x) => {
      x.PaymentLinkState = this.getPaymentLinkStateString(x.PaymentLinkState) as any;
      return x;
    });
  }

  public getPaymentLinkStateString(paymentLinkState: number): string {
    let paymentLinkStateString = "";

    switch (this.getStatusOfLinkPayment(paymentLinkState)) {
      case PaymentLinkState.Nothing:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.Sending");
        break;
      case PaymentLinkState.SentLink:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.LinkSent");
        break;
      case PaymentLinkState.DeliveredLink:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.LinkReceived");
        break;
      case PaymentLinkState.Paying:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.Paying");
        break;
      case PaymentLinkState.Paid:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.Paid");
        break;
      case PaymentLinkState.FailPayment:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.ProblemPaying");
        break;
      case PaymentLinkState.OpenFactorLink:
        paymentLinkStateString = this.translate("ClientApp.FrontOffice.Financial.InvoicesModal.OpeningPaymentLinkByCustomer");
        break;
      default:
        break;
    }

    return paymentLinkStateString;
  }

  public getStatusOfLinkPayment(paymentLinkState: number | null): number {
    if (paymentLinkState === null) {
      return -1000; //A Value that cannot be used
    }

    const numberStr = paymentLinkState.toString();
    const restOfDigitsStr = numberStr.substring(1, 3);
    return parseInt(restOfDigitsStr, 10);
  }

  async setColumns() {
    this.hasColumns = true;
    let api: string;
    if (this.invoices) {
      api = "Invoice";
      // this.currentData = this.invoices;
    }
    if (this.settlement) {
      api = "CashierSettlemet";
      this.currentData = this.settlement;
    }
    if (this.reciptpayment) {
      api = "ReceiptPayment";
      this.currentData = this.reciptpayment;
    }
    if (this.CostSpents) {
      api = "CostSpent";
      this.currentData = this.CostSpents;
    }
    if (!api) api = "Invoice";
    this.httpCommonService
      .getControlsList(api)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: form_control[]) => {
        if (data) {
          if (api === "Invoice") {
            data.findIndex((x) => x.name === "");
          }
          this.columns = data;
          this.columns.forEach((x) => {
            if (x.name === "NumberingInDate") {
              x.order = 0;
            }
            if (x.name === "BranchTitle") {
              x.order = 1;
            }
            if (x.name === "BranchTitle") {
              x.order = 1;
            }
            if (x.name === "StatusTitle") {
              x.order = 1;
            }
            if (x.name === "CustomerNumber") {
              x.order = 1;
            }
            if (x.name === "CustomerDisplayName") {
              x.order = 1;
            }
            if (x.name === "ShamsiCreatedDate") {
              x.order = 1;
            }
            if (x.name === "CreatedDateTime") {
              x.order = 1;
            }
            if (x.name === "PayableTotal") {
              x.order = 1;
            }
            if (x.name === "SaleMethodBranchTitle") {
              x.order = 1;
            }
          });
          this.columns = this.columns.sort((a, b) => a.order - b.order);
        }
      });
  }
  onDataStateChanged(event: GridFilter[]) {
    this.FillData(event);
  }
  cancel() {
    this.closeModal();
  }
}
